import { render, staticRenderFns } from "./OutboundOrderSendScan.vue?vue&type=template&id=b868ae58&scoped=true&"
import script from "./OutboundOrderSendScan.vue?vue&type=script&lang=js&"
export * from "./OutboundOrderSendScan.vue?vue&type=script&lang=js&"
import style0 from "./OutboundOrderSendScan.vue?vue&type=style&index=0&id=b868ae58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b868ae58",
  null
  
)

export default component.exports